/**适配*/
import GlobalInfo from '../GlobalInfo.vue';

function isQQBrowser() {
    var userAgent = navigator.userAgent.toLowerCase();
    var qqBrowserSignatures = [
		'micromessenger',
        'qqbrowser', // 标准的QQ浏览器标识
        'mqqbrowser', // 移动版的QQ浏览器标识
        'qq/', // 一些旧版本的QQ浏览器可能使用这种标识
    ];

    for (var i = 0; i < qqBrowserSignatures.length; i++) {
        if (userAgent.indexOf(qqBrowserSignatures[i]) > -1&&!userAgent.includes("mac os")) {
            return true;
        }
    }
    return false;
};

(function (doc, win) {
    var docEl = doc.documentElement,
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function () {
            var clientWidth = docEl.clientWidth;
            if (!clientWidth) return;
			if(isQQBrowser() && clientWidth < 1280){
				docEl.style.fontSize = '10px';
				docEl.style.zoom = clientWidth / GlobalInfo.fitData.windowSize.width;
			}else{
				docEl.style.fontSize = GlobalInfo.fitData.fontSize * (clientWidth / GlobalInfo.fitData.windowSize.width) + 'px';
			}
        };
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);